import { WorkspaceShell } from '@/components/workspace/WorkspaceShell';

export default function App() {
  return <WorkspaceShell />;
}
